export const getEnv = key => {
  const envLocal = {
    REACT_APP_BACKEND_IP_ADDRESS: process.env.REACT_APP_BACKEND_IP_ADDRESS,
    REACT_APP_BASE_URL: process.env.REACT_APP_BASE_URL,
    REACT_APP_COUNTRY: process.env.REACT_APP_COUNTRY,
    REACT_APP_LINE_CHANNEL_ID: process.env.REACT_APP_LINE_CHANNEL_ID,
    REACT_APP_LIFF_ID: process.env.REACT_APP_LIFF_ID,
    NODE_ENV: process.env.NODE_ENV,
    ENABLE_SEMANTIC_SEARCH: process.env.ENABLE_SEMANTIC_SEARCH
  };
  if (process.env.NODE_ENV !== 'production') {
    return envLocal[key];
  }
  //read from env-config.js file injected at runtime
  return window.__env__[key];
};

if (process.env.NODE_ENV === 'production' && !window.__env__) {
  console.warn('⚠️ Runtime environment config not found (yet) (env-config.js missing).');
}
